import React, {useRef} from "react"
import {DefaultTablePagination, Popconfirm, Table, Tooltip} from "../../../components/Elements/appUtils"
import {patientPurchaseFxn} from "../actions/patients";
import moment from "moment";

const PatientPurchaseList = (props) => {
    let tableRef = useRef()
    const apiRequest = (params) => {
        return new Promise(async (resolve) => {
            params.customerId = props.customerId;
            let resp = await patientPurchaseFxn(params);
            resolve(resp)
        })
    }
    const columns = [
        {
            title: "Sr. No",
            dataIndex: "serialNo",
            key: "serialNo",
            render: (text, record, index) => index + 1,
        },
        {
            title: "Vendor",
            dataIndex: "customerId",
            key: "customerId",
            render: (text) => <span>{text?.name}</span>,
        },
        {
            title: "Invoice Number",
            dataIndex: "invoiceNumber",
            key: "invoiceNumber",
        },
        {
            title: "Date of Receiving product",
            dataIndex: "purchaseDate",
            key: "purchaseDate",
            render: (text) => <span>{moment(text).format("DD-MMM-YYYY")}</span>,
        },
        {
            title: "State",
            dataIndex: "customerId",
            key: "customerId",
            render: (text) => <span>{text?.state}</span>,
        },
        {
            title: "Total Quantity",
            dataIndex: "quantity",
            key: "quantity",
        },
        {
            title: "Total Amount",
            dataIndex: "totalAmount",
            key: "totalAmount",
            render: (text) => <span>Rs. {text}</span>,
        },
        {
            title: "Paid Amount",
            dataIndex: "paidAmount",
            key: "paidAmount",
            render: (text) => <span>Rs. {text}</span>,
        },
        {
            title: "Balance",
            dataIndex: "balance",
            key: "balance",
            render: (text) => <span>Rs. {text}</span>,
        }
    ];

    return (
        <div>
            <Table
                apiRequest={apiRequest}
                columns={columns}
                ref={tableRef}
                position={"top"}
                pagination={{...DefaultTablePagination(), defaultPageSize: 50}}

            />
        </div>
    )
}
export default PatientPurchaseList